import React from "react";
import { Outlet } from "react-router-dom";

const Laundry = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Laundry;
